// extracted by mini-css-extract-plugin
export var actionButton = "_fa-0";
export var fileInput = "_fa-2";
export var paperclip = "_fa-1";